enum Language {
  English = 'en',
  Ukraine = 'uk',
  Russian = 'ru',
}

export default Language;
